function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

(async () => {
  var e = await import(window.theme.modules.baseComponent);
  customElements.define(
    "slides-variant-changer",
    class extends e.default {
      constructor(...args) {
        super(...args);

        _defineProperty(this, "elements", {
          slideShow: "slide-show",
        });
      }

      render() {
        this.$slideShow &&
          this.listenTo("variantChange", (e, i) => {
            i.variant.featured_media &&
              this.$slideShow.slideTo(i.variant.featured_media.position - 1);
          });
      }
    }
  );
})();
